export default "__VITE_ASSET__2ee0806b__"